/** Hostnames whose UI is served separately but use production API/auth/JaaS backends. */
export const PRODUCTION_HOSTNAMES = [
  'meetings.sangoma.com',
  'preview.meetings.sangoma.com',
];

export function usesProductionBackend(hostname) {
  return PRODUCTION_HOSTNAMES.includes(hostname);
}
export const STAGING_HOSTNAMES = [
  'staging.meetings.sangoma.com',
];

export const NOC_HOSTNAMES = [...PRODUCTION_HOSTNAMES, ...STAGING_HOSTNAMES];
